
import Button from '../../../components/base/Button';

export default function ServicesList() {
  const services = [
    {
      id: 'website-design',
      title: 'Website Design & Development',
      subtitle: 'Custom E-commerce & Corporate Websites',
      description: 'We create stunning, conversion-optimized websites that not only look great but also drive results. Our designs are mobile-responsive, fast-loading, and built with SEO best practices.',
      features: [
        'E-commerce Website Design',
        'Informational/Corporate Website Design',
        'Mobile-Responsive Design',
        'SEO-Optimized Structure',
        'Fast Loading Speed',
        'Conversion Optimization'
      ],
      process: [
        'Discovery & Strategy',
        'Design & Prototyping',
        'Development & Testing',
        'Launch & Optimization'
      ],
      results: 'Average 40% increase in conversion rates',
      image: 'https://public.readdy.ai/ai/img_res/84241e9aebf51481e464501bfcc60c9d.jpg'
    },
    {
      id: 'meta-ads',
      title: 'Meta Ads (Facebook & Instagram)',
      subtitle: 'Social Media Advertising Excellence',
      description: 'Drive targeted traffic and sales through strategic Facebook and Instagram advertising campaigns. We create compelling ad creatives and optimize for maximum ROI.',
      features: [
        'Campaign Strategy Development',
        'Ad Creative Design',
        'Audience Targeting',
        'A/B Testing',
        'Performance Optimization',
        'Detailed Reporting'
      ],
      process: [
        'Audience Research',
        'Creative Development',
        'Campaign Launch',
        'Optimization & Scaling'
      ],
      results: 'Average 250% ROAS improvement',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20advertising%20dashboard%20with%20Facebook%20and%20Instagram%20ads%20performance%20metrics%2C%20colorful%20charts%20and%20analytics%2C%20modern%20digital%20marketing%20interface%2C%20engagement%20statistics&width=600&height=400&seq=meta-ads&orientation=landscape'
    },
    {
      id: 'seo',
      title: 'SEO (Search Engine Optimization)',
      subtitle: 'Organic Growth & Visibility',
      description: 'Improve your search engine rankings and drive organic traffic with our comprehensive SEO strategies. We focus on both technical and content optimization.',
      features: [
        'On-page SEO Optimization',
        'Off-page Link Building',
        'Technical SEO Audit',
        'Keyword Research',
        'Content Strategy',
        'Local SEO'
      ],
      process: [
        'SEO Audit',
        'Strategy Development',
        'Implementation',
        'Monitoring & Reporting'
      ],
      results: 'Average 150% increase in organic traffic',
      image: 'https://readdy.ai/api/search-image?query=SEO%20analytics%20dashboard%20showing%20search%20rankings%20and%20organic%20traffic%20growth%2C%20Google%20search%20results%20page%2C%20keyword%20performance%20charts%2C%20digital%20marketing%20metrics&width=600&height=400&seq=seo-service&orientation=landscape'
    },
    {
      id: 'google-ads',
      title: 'Google Ads',
      subtitle: 'Search, Display, Shopping & YouTube Ads',
      description: 'Maximize your reach with comprehensive Google Ads campaigns across search, display, shopping, and YouTube platforms. Drive qualified leads and sales.',
      features: [
        'Search Ads Management',
        'Display Advertising',
        'Shopping Campaigns',
        'YouTube Advertising',
        'Conversion Tracking',
        'Bid Optimization'
      ],
      process: [
        'Keyword Research',
        'Campaign Setup',
        'Ad Creation',
        'Performance Monitoring'
      ],
      results: 'Average 200% increase in qualified leads',
      image: 'https://readdy.ai/api/search-image?query=Google%20Ads%20dashboard%20interface%20showing%20campaign%20performance%2C%20search%20advertising%20metrics%2C%20PPC%20management%20tools%2C%20colorful%20analytics%20charts%20and%20graphs&width=600&height=400&seq=google-ads&orientation=landscape'
    },
    {
      id: 'smo',
      title: 'Social Media Optimization (SMO)',
      subtitle: 'Complete Social Media Strategy',
      description: 'Build a strong social media presence with our comprehensive SMO services. From account setup to growth strategy, we handle all aspects of your social media.',
      features: [
        'Account Setup & Optimization',
        'Profile Enhancement',
        'Content Strategy',
        'Community Management',
        'Growth Optimization',
        'Analytics & Reporting'
      ],
      process: [
        'Platform Analysis',
        'Strategy Development',
        'Content Creation',
        'Community Building'
      ],
      results: 'Average 300% increase in social engagement',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20management%20dashboard%20with%20multiple%20platform%20analytics%2C%20engagement%20metrics%2C%20content%20calendar%2C%20colorful%20social%20media%20icons%20and%20statistics&width=600&height=400&seq=smo-service&orientation=landscape'
    },
    {
      id: 'content-creation',
      title: 'Content Creation',
      subtitle: 'Engaging Content That Converts',
      description: 'Create compelling content that resonates with your audience and drives engagement. From social media posts to blog articles, we craft content that converts.',
      features: [
        'Social Media Content',
        'Video & Reels Creation',
        'Blog Writing',
        'Copywriting',
        'Visual Content Design',
        'Content Strategy'
      ],
      process: [
        'Content Planning',
        'Creation & Design',
        'Review & Approval',
        'Publishing & Promotion'
      ],
      results: 'Average 180% increase in engagement',
      image: 'https://readdy.ai/api/search-image?query=Content%20creation%20workspace%20with%20creative%20materials%2C%20video%20production%20setup%2C%20writing%20tools%2C%20design%20elements%2C%20modern%20creative%20studio%20environment&width=600&height=400&seq=content-creation&orientation=landscape'
    },
    {
      id: 'performance-marketing',
      title: 'Performance Marketing',
      subtitle: 'End-to-End Growth Strategy',
      description: 'Comprehensive performance marketing approach with conversion tracking, ROAS optimization, and data-driven strategies for sustainable growth.',
      features: [
        'Full-Funnel Strategy',
        'Conversion Tracking',
        'ROAS Optimization',
        'Multi-Channel Campaigns',
        'Advanced Analytics',
        'Growth Scaling'
      ],
      process: [
        'Strategy Development',
        'Implementation',
        'Testing & Optimization',
        'Scaling & Growth'
      ],
      results: 'Average 400% improvement in ROAS',
      image: 'https://readdy.ai/api/search-image?query=Performance%20marketing%20analytics%20dashboard%20with%20ROI%20metrics%2C%20conversion%20tracking%20data%2C%20multi-channel%20campaign%20results%2C%20advanced%20marketing%20analytics%20interface&width=600&height=400&seq=performance-marketing&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {services.map((service, index) => (
          <div key={service.id} id={service.id} className={`mb-20 ${index !== 0 ? 'pt-16 border-t border-gray-200' : ''}`}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h2>
                <h3 className="text-xl text-blue-600 font-semibold mb-6">
                  {service.subtitle}
                </h3>
                <p className="text-lg text-gray-600 mb-8">
                  {service.description}
                </p>

                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">What's Included:</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <div className="w-4 h-4 flex items-center justify-center mr-3">
                          <i className="ri-check-line text-green-600"></i>
                        </div>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Our Process:</h4>
                  <div className="flex flex-wrap gap-2">
                    {service.process.map((step, idx) => (
                      <span key={idx} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                        {idx + 1}. {step}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="bg-green-50 p-4 rounded-lg mb-8">
                  <div className="flex items-center">
                    <div className="w-6 h-6 flex items-center justify-center mr-3">
                      <i className="ri-trophy-line text-green-600 text-xl"></i>
                    </div>
                    <span className="text-green-800 font-semibold">{service.results}</span>
                  </div>
                </div>

                <Button variant="primary" size="lg" href="/contact">
                  Get Started Today
                </Button>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <img 
                  src={service.image}
                  alt={service.title}
                  className="rounded-lg shadow-lg object-cover w-full h-96"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
